/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ICollectorReportReq,
  ICollectorReportRes,
  ICustomerOrderReportReq,
  ICustomerOrderReportRes,
  IFinancialMatchingReportRes,
  IImportFinancialMatchingReportReq,
  INotePurchaseReport,
  ISalesReportSumByMonthReq,
  ISalesReportSumByMonthRes,
  ISearchNotePurchaseReportReq,
  ISearchSafetyStockReportReq,
  ISearchSafetyStockReportRes,
  ISearchSalesReportReq,
  ISearchSalesReportRes,
  ISearchTaxInvoiceReportReq,
  IStockMatchingReportReq,
  IStockMatchingReportRes,
  ITaxInvoice,
} from '@/interfaces/report';
import * as baseAdapter from './baseAdapter';
import {
  ILocationCheckingReq,
  ILocationCheckingRes,
} from '@/interfaces/location';

export const searchSalesReport = async (req: ISearchSalesReportReq) => {
  const ret = await baseAdapter.post<ISearchSalesReportRes>(
    '/report/salesReport',
    req,
  );
  return ret;
};

export const searchSalesReportByMonth = async (
  req: ISalesReportSumByMonthReq,
) => {
  const ret = await baseAdapter.post<ISalesReportSumByMonthRes[]>(
    '/report/salesReportByMonth',
    req,
  );
  return ret;
};

export const searchSafetyStockReport = async (
  req: ISearchSafetyStockReportReq,
) => {
  const ret = await baseAdapter.post<ISearchSafetyStockReportRes[]>(
    '/report/safetyStockReport',
    req,
  );
  return ret;
};

export const searchCollectorReport = async (req: ICollectorReportReq) => {
  const ret = await baseAdapter.post<ICollectorReportRes[]>(
    '/report/collectorReport',
    req,
  );
  return ret;
};

export const searchCustomerOrderReport = async (
  req: ICustomerOrderReportReq,
) => {
  const ret = await baseAdapter.post<ICustomerOrderReportRes[]>(
    '/report/customerOrderReport',
    req,
  );
  return ret;
};

export const searchTaxInvoiceReport = async (
  req: ISearchTaxInvoiceReportReq,
) => {
  const ret = await baseAdapter.post<ITaxInvoice[]>(
    '/report/taxInvoiceReport',
    req,
  );
  return ret;
};

export const searchNotePurchaseReport = async (
  req: ISearchNotePurchaseReportReq,
) => {
  const ret = await baseAdapter.post<INotePurchaseReport[]>(
    '/report/notePurchaseReport',
    req,
  );
  return ret;
};

export const importFinancialMatching = async (
  req: IImportFinancialMatchingReportReq,
) => {
  const ret = await baseAdapter.post<boolean>(
    '/report/importFinancialMatching',
    req,
  );
  return ret;
};

export const getFinancialMatching = async (
  req: IImportFinancialMatchingReportReq,
) => {
  const ret = await baseAdapter.post<IFinancialMatchingReportRes[]>(
    '/report/getFinancialMatching',
    req,
  );
  return ret;
};

export const updateFinancialMatching = async (
  req: IImportFinancialMatchingReportReq,
) => {
  const ret = await baseAdapter.post<boolean>(
    '/report/updateFinancialMatching',
    req,
  );
  return ret;
};

export const importStockMatching = async (req: IStockMatchingReportReq) => {
  const ret = await baseAdapter.post<boolean>(
    '/report/importStockMatching',
    req,
  );
  return ret;
};

export const getStockMatching = async (req: IStockMatchingReportReq) => {
  const ret = await baseAdapter.post<IStockMatchingReportRes[]>(
    '/report/getStockMatching',
    req,
  );
  return ret;
};

export const searchLocationCheckingReport = async (
  req: ILocationCheckingReq,
) => {
  const ret = await baseAdapter.post<ILocationCheckingRes[]>(
    '/report/getLocationChecking',
    req,
  );
  return ret;
};

export const updateLocationChecking = async (
  req: Partial<ILocationCheckingRes>,
) => {
  const ret = await baseAdapter.post<boolean>('/report/updateLocation', req);
  return ret;
};

export const getLocationCount = async (req: Partial<ILocationCheckingReq>) => {
  const ret = await baseAdapter.post<number>('/report/getLocationCount', req);
  return ret;
};
